import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl, Max, Min, Required } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrOrgEmpTypeGroupedEmpCountQueryModel')
export class OrgEmpTypeGroupedEmpCountQueryModel {
    @Max(999)
    @Min(1)
    @Required()
    @JsonProperty('orgObjDefIdList', [Number], true)
    orgObjDefIdList: Array<number> = null;

    @EmptyControl()
    @JsonProperty('objectDefinitionStatuses', [Number], true)
    objectDefinitionStatuses?: Array<number> = null;
}
